export enum BackendErrorType {
  FILE_SIZE_ERROR = '002',
  SEND_EMAIL_FAIL_ERROR = '003'
}
